<template>
    <modal
      name="receiptUpdatesForm"
      classes="v-modal-sec"
      :min-width="500"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="500px"
      height="auto"
    >
      <div class="v-modal profile_details_modal update-tracking-details-modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">Update Receipt Notice</h2>
          <span @click="hideReceipt()">
            <em class="material-icons">close</em> 
          </span>
        </div>
        <h5 v-if="checkProperty(petition, 'caseNo')" class="sub-title padl20 pt-4 mb-0">Case No: <strong>{{ checkProperty(petition, 'caseNo') }}</strong></h5>
        <div class="receipt_updates pb-5" v-if="checkSectionVal('beneficiary')">
            <h5>Receipt </h5>
            <ul>
                <template v-for="(receit, ind) in receiptDataList ">
                    <template v-if="checkProperty(receit, 'category') == 'beneficiary'">
                        <li :key="ind" >
                            <div class="list__item" >
                                <vs-checkbox @input="clearSelected(receit)" :name="'selected_'+ind" v-model="receit.isSelected">
                                    <label v-if="checkProperty(receit, 'name')">{{ checkProperty(receit, 'name') }}
                                        <span style="text-transform: capitalize;">{{ checkProperty(receit, 'subTitle')  }}</span>
                                    </label>
                                </vs-checkbox>                             
                            </div>
                        </li>
                    </template>
                   
                </template>
                
            </ul>
        </div>
        <div class="receipt_updates pt-0 pb-5" v-if="checkSectionVal('ead') && [2].indexOf(checkProperty(petition, 'typeDetails', 'id'))>-1 && checkProperty(petition,'beneficiaryInfo', 'h4EADRequired')">
            <h5>Beneficiary EAD</h5>
            <ul>
                <template v-for="(receit, ind) in receiptDataList ">
                    <template v-if="checkProperty(receit, 'type') == 'ead'">
                        <li :key="ind">
                            <div class="list__item">
                                <vs-checkbox @input="clearSelected(receit)" :name="'selected_'+ind" v-model="receit.isSelected">
                                    <label v-if="checkProperty(receit, 'name')">{{ checkProperty(receit, 'name') }}
                                        <span style="text-transform: capitalize;">{{ checkProperty(receit, 'subTitle')  }}</span>
                                    </label>
                                </vs-checkbox>                     
                            </div>
                        </li>
                    </template>
                </template>
                
            </ul>
        </div>
        <div class="receipt_updates  pt-0 pb-5" v-if="checkSectionVal('h4')">
            <h5>H4 Receipt </h5>
            <ul>
                <template v-for="(receit, ind) in receiptDataList ">
                    <template v-if="checkProperty(receit, 'type') == 'h4'">
                        <li :key="ind">
                            <div class="list__item">
                                <vs-checkbox @input="clearSelected(receit)" :name="'selected_'+ind" v-model="receit.isSelected">
                                    <label v-if="checkProperty(receit, 'name')">{{ checkProperty(receit, 'name') }}
                                        <span style="text-transform: capitalize;">{{ checkProperty(receit, 'subTitle')  }}</span>
                                    </label>
                                </vs-checkbox>                  
                            </div>
                        </li>
                    </template>
                   
                </template>
                
            </ul>
        </div>
        <div class="receipt_updates pt-0 pb-5" v-if="checkSectionVal('h4ead')">
            <h5>H4 EAD Receipt </h5>
            <ul>
                <template v-for="(receit, ind) in receiptDataList ">
                    <template v-if="checkProperty(receit, 'type') == 'h4ead'">
                        <li :key="ind">
                            <div class="list__item">
                                <vs-checkbox @input="clearSelected(receit)" :name="'selected_'+ind" v-model="receit.isSelected">
                                    <label v-if="checkProperty(receit, 'name')">{{ checkProperty(receit, 'name') }}
                                        <span style="text-transform: capitalize;">{{ checkProperty(receit, 'subTitle')  }}</span>
                                    </label>
                                </vs-checkbox>                       
                            </div>
                        </li>
                    </template>
                   
                </template>
                
            </ul>
        </div>
       
        <form @submit.prevent data-vv-scope="trackingform" class="trackingform" v-if="returnSelectedObj !=null" >
          <div class="form-container padlr20 mt-0"  @click="receiptNoticesUpdateError=''">
            <div class="divider mb-4 mt-0"></div>
            <div class="vx-row">

                <immiInput :allowFloatingPoint="false" :maxLength="13"  :display="true" :cid="'receiptNumber'" formscope="trackingform"
                v-model="selectedTrackingData.receiptNumber"  :fieldName="'receiptNumber'"  :required="true"  label="Receipt Number" placeHolder="Receipt Number" />

                <datepickerField  :display="true"  :validationRequired="true"
                v-model="selectedTrackingData.receivedDate" formscope="trackingform" :dateEnableTo="new Date()"  
                :fieldName="'receivedDate'"  label="Received Date" />

            </div>
            <div class="vx-row pt-0 pb-5" v-if="getTenantTypeId != 2 && checkProperty(petition, 'petitionerId')" >
            <div class="vx-col w-full"   >
              <ul
                class="demo-alignment custom-radio notify_checks"
                vs-type="flex"
                vs-align="center">
                <li class="mt-0">
                  <vs-checkbox
                    vs-name="notifyPetitioner"
                    v-model="notifyPetitioner"
                  ><span>{{ checkProperty(petition, "typeDetails", "id")==4?"Notify Sponsor":"Notify Petitioner"}}</span>
                  </vs-checkbox>
                </li>
              </ul>
            </div>
          </div>
          </div>
          <div @click="receiptNoticesUpdateError=''" class="text-danger text-sm formerrors" v-if="receiptNoticesUpdateError!=''">
                <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal" icon="IP-information-button" active="true">{{ receiptNoticesUpdateError }}</vs-alert>
            </div>
          <div class="popup-footer relative" >
            <span class="loader" v-if="loading"><img src="@/assets/images/main/loader.gif"></span>
            <vs-button color="dark"  class="cancel" type="filled" @click="hideReceipt()">Cancel</vs-button>
            <vs-button  color="success" class="save" type="filled" @click="submitForm()">Submit</vs-button>
          </div>
        </form>
      </div>
    </modal>
  </template>
  <script>
  import moment from "moment";
  import { EyeIcon } from "vue-feather-icons";
  import immiInput from "@/views/forms/fields/simpleinput.vue";
  import datepickerField from "@/views/forms/fields/datepicker.vue";
  import * as _ from "lodash";
  
  export default {
    provide() {
        return {
            parentValidator: this.$validator,
        };
    },
    components: {
      EyeIcon,
      immiInput,
      datepickerField
    },
    methods:{
        clearSelected(tr){
            let self = this;
            if(this.checkProperty(tr ,'isSelected') &&  this.checkProperty(this.receiptDataList,'length')>0 ){
                _.forEach(this.receiptDataList,(item) => {
                    if(((item['type'] == self.checkProperty(tr,'type')) && (item['category'] == self.checkProperty(tr,'category')) && !self.checkProperty(tr,'childrenId')) ||
                     (self.checkProperty(tr,'childrenId') && item['childrenId'] == self.checkProperty(tr,'childrenId') ) ){
                       
                    }else{
                        item['isSelected'] = false;
                    }
                })
            }
        },
        getReceiptData(){
            let receiptList = [];
            this.spouseExists = false;
            if(this.petition){
                if(this.checkProperty(this.petition, 'beneficiaryInfo', 'name')){
                    let objBen = {
                        name:this.checkProperty(this.petition, 'beneficiaryInfo', 'name'),
                        subTitle:'Beneficiary',
                        type:'beneficiary',
                        category:'beneficiary',
                        isSelected:false,
                        action:'UPDATE_USCIS_RECEIPT_NUMBER',
                        isAlreadyUpdated:false,
                        receiptNumber:'',
                        receivedDate:null
                    }
                    if(this.checkProperty(this.petition, 'completedActivities') && this.checkProperty(this.petition, 'completedActivities', 'length')>0 && this.petition.completedActivities.indexOf('UPDATE_USCIS_RECEIPT_NUMBER')>-1
                        && this.checkProperty(this.petition ,'courierTrackingDetails' ,'length')>0  ){
                            _.forEach(this.petition['courierTrackingDetails'], (item)=>{
                                if(['UPDATE_USCIS_RECEIPT_NUMBER'].indexOf(this.checkProperty(item ,'category'))>-1&& !this.checkProperty(item ,'categoryType')){
                                    objBen['receiptNumber'] = this.checkProperty(item, 'receiptNumber');
                                    objBen['receivedDate'] = this.checkProperty(item, 'receivedDate');
                                    objBen['isAlreadyUpdated'] = true
                                }
                            })
                            receiptList.push(objBen);
                    }else{
                        receiptList.push(objBen);
                    }

                    
                }
            }
            if(this.petition && [2].indexOf(this.checkProperty(this.petition, 'typeDetails', 'id'))>-1 && this.checkProperty(this.petition,'beneficiaryInfo', 'h4EADRequired')  ){
                if(this.checkProperty(this.petition, 'beneficiaryInfo', 'name')){
                    let objBenEad = {
                        name:this.checkProperty(this.petition, 'beneficiaryInfo', 'name'),
                        subTitle:'Beneficiary',
                        type:'ead',
                        category:'beneficiary',
                        isSelected:false,
                        action:'UPDATE_USCIS_RECEIPT_NUMBER_EAD',
                        isAlreadyUpdated:false,
                        receiptNumber:'',
                        receivedDate:null
                    }
                    if(this.checkProperty(this.petition, 'completedActivities') && this.checkProperty(this.petition, 'completedActivities', 'length')>0 && this.petition.completedActivities.indexOf('UPDATE_USCIS_RECEIPT_NUMBER_EAD')>-1
                        && this.checkProperty(this.petition ,'courierTrackingDetails' ,'length')>0  ){
                            _.forEach(this.petition['courierTrackingDetails'], (item)=>{
                                if(['UPDATE_USCIS_RECEIPT_NUMBER_EAD'].indexOf(this.checkProperty(item ,'category'))>-1 && this.checkProperty(item ,'categoryType') == 'ead'){
                                    objBenEad['receiptNumber'] = this.checkProperty(item, 'receiptNumber');
                                    objBenEad['receivedDate'] = this.checkProperty(item, 'receivedDate');
                                    objBenEad['isAlreadyUpdated'] = true
                                }
                            })
                            receiptList.push(objBenEad);
                    }else{
                        receiptList.push(objBenEad);
                    }
                    
                }
            }
            if(this.checkProperty(this.petition ,'beneficiaryInfo' ,'maritalStatus') && this.checkProperty(this.petition ,'beneficiaryInfo' ,'maritalStatus') !=1){
                if(this.checkProperty(this.petition ,'dependentsInfo' ,'spouse') && ((this.isH1bCase &&this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'h4Required')) || 
                (this.isL1Case &&this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'l2Required')) || (this.isL2Case &&this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'hasSpouse'))
                    || (this.isH4Case && this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'hasSpouse'))) ){
                    if(this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'name')){
                       let objSpouse = {
                            name:this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'name'),
                            subTitle:'Spouse',
                            type:'h4',
                            category:'spouse',
                            isSelected:false,
                            action:'UPDATE_USCIS_RECEIPT_NUMBER',
                            isAlreadyUpdated:false,
                            receiptNumber:'',
                            receivedDate:null
                        }
                        if(this.checkProperty(this.petition, 'completedActivities') && this.checkProperty(this.petition, 'completedActivities', 'length')>0 && this.petition.completedActivities.indexOf('UPDATE_USCIS_RECEIPT_NUMBER_H4')>-1
                        && this.checkProperty(this.petition ,'courierTrackingDetails' ,'length')>0  ){
                            _.forEach(this.petition['courierTrackingDetails'], (item)=>{
                                if(['UPDATE_USCIS_RECEIPT_NUMBER'].indexOf(this.checkProperty(item ,'category'))>-1 && this.checkProperty(item ,'categoryType') == 'h4' && this.checkProperty(item ,'userType' )=='spouse'){
                                    objSpouse['receiptNumber'] = this.checkProperty(item, 'receiptNumber');
                                    objSpouse['receivedDate'] = this.checkProperty(item, 'receivedDate');
                                    objSpouse['isAlreadyUpdated'] = true
                                }
                            })
                            receiptList.push(objSpouse);
                        }else{
                            receiptList.push(objSpouse);
                        }
                        this.spouseExists = true;
                           
                    }
                }
                if(this.checkProperty(this.petition ,'dependentsInfo' ,'spouse') && (this.isH1bCase && this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'h4EADRequired'))  ){
                    if(this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'name')){
                        let objSpouseEad = {
                            name:this.checkProperty(this.petition['dependentsInfo'] ,'spouse', 'name'),
                            subTitle:'Spouse',
                            type:'h4ead',
                            category:'spouse',
                            childrenId:'',
                            isSelected:false,
                            action:'UPDATE_USCIS_RECEIPT_NUMBER',
                            isAlreadyUpdated:false,
                            receiptNumber:'',
                            receivedDate:null
                        }
                        if(this.checkProperty(this.petition, 'completedActivities') && this.checkProperty(this.petition, 'completedActivities', 'length')>0 && this.petition.completedActivities.indexOf('UPDATE_USCIS_RECEIPT_NUMBER_H4_EAD')>-1
                        && this.checkProperty(this.petition ,'courierTrackingDetails' ,'length')>0  ){
                            _.forEach(this.petition['courierTrackingDetails'], (item)=>{
                                if(['UPDATE_USCIS_RECEIPT_NUMBER'].indexOf(this.checkProperty(item ,'category'))>-1 && this.checkProperty(item ,'categoryType') == 'h4ead' && this.checkProperty(item ,'userType' )=='spouse'){
                                    objSpouseEad['receiptNumber'] = this.checkProperty(item, 'receiptNumber');
                                    objSpouseEad['receivedDate'] = this.checkProperty(item, 'receivedDate');
                                    objSpouseEad['isAlreadyUpdated'] = true
                                }
                            })
                            receiptList.push(objSpouseEad);
                        }else{
                            receiptList.push(objSpouseEad);
                        }
                    }
                }
                if(this.checkProperty(this.petition ,'dependentsInfo' ,'childrens') && this.checkProperty(this.petition['dependentsInfo'] ,'childrens', 'length')>0){
                    _.forEach(this.checkProperty(this.petition ,'dependentsInfo' ,'childrens'), (childItem, childIndex)=>{
                        
                        if((this.isH1bCase && this.checkProperty(childItem, 'h4Required')) || (this.isL1Case && this.checkProperty(childItem, 'l2Required')) || 
                            (this.isL2Case && this.checkProperty(childItem, 'hasChildren')) || (this.isH4Case && this.checkProperty(childItem, 'hasChildren'))){
                                if(this.checkProperty(childItem, 'name')){
                                    let childObj = {
                                        name:this.checkProperty(childItem, 'name'),
                                        subTitle:'Children',
                                        type:'h4',
                                        category:'children',
                                        childrenId:this.checkProperty(childItem, '_id'),
                                        isSelected:false,
                                        action:'UPDATE_USCIS_RECEIPT_NUMBER',
                                        isAlreadyUpdated:false,
                                        receiptNumber:'',
                                        receivedDate:null,
                                        childIndex:null
                                    }
                                    if(childIndex){
                                        childObj['childIndex'] = childIndex+1
                                    }
                                    if(this.checkProperty(this.petition, 'completedActivities') && this.checkProperty(this.petition, 'completedActivities', 'length')>0 && this.petition.completedActivities.indexOf('UPDATE_USCIS_RECEIPT_NUMBER_H4')>-1
                                        && this.checkProperty(this.petition ,'courierTrackingDetails' ,'length')>0  ){
                                        _.forEach(this.petition['courierTrackingDetails'], (item)=>{
                                            if(['UPDATE_USCIS_RECEIPT_NUMBER'].indexOf(this.checkProperty(item ,'category'))>-1 && this.checkProperty(item ,'categoryType' )=='h4'  &&
                                            this.checkProperty(item ,'userType' )=='children' && this.checkProperty(item ,'childrenId' ) ==this.checkProperty(childItem, '_id') ){
                                                childObj['receiptNumber'] = this.checkProperty(item, 'receiptNumber');
                                                childObj['receivedDate'] = this.checkProperty(item, 'receivedDate');
                                                childObj['isAlreadyUpdated'] = true
                                            }
                                            
                                        })
                                        receiptList.push(childObj);
                                    }else{
                                        receiptList.push(childObj);
                                    }
                                    childObj = {
                                        name:'',
                                        subTitle:'',
                                        type:'',
                                        category:'',
                                        childrenId:'',
                                        isSelected:false,
                                        action:'',
                                        isAlreadyUpdated:false,
                                        receiptNumber:'',
                                        receivedDate:null,
                                        childIndex:null
                                    }
                                }
                        }
                    })
                }
            }
            if(receiptList && receiptList.length>0){
                this.receiptDataList = receiptList;
            }
        },
        hideReceipt(callFromSuccess = false) {
            this.$modal.hide('receiptUpdatesForm')
            this.$emit("hideReceipt", callFromSuccess);
        },
        getNoticeDocName(data){
            let selectedData = data;
            let fileNames = [];
            if(this.checkProperty(selectedData, 'documents', 'length')>0){
                let documents =  this.checkProperty(selectedData, 'documents')
                if(this.selectedCategory == 'beneficiary'){
                    if(this.checkProperty(selectedData, 'userName')){
                        fileNames.push(this.checkProperty(selectedData, 'userName'))
                    }
                    if(this.companyName != ''){
                        fileNames.push(this.companyName)
                    }
                    fileNames.push('I-129');
                    fileNames.push('Receipt Notice.pdf');
                    
                }else if(this.selectedCategory != 'beneficiary'){
                    if(this.checkProperty(selectedData, 'userName')){
                        fileNames.push(this.checkProperty(selectedData, 'userName'))
                    }
                    if(this.companyName != ''){
                        fileNames.push(this.companyName)
                    }
                    if(this.selectedCategory == 'h4'){
                        if(this.checkProperty(selectedData, 'userType') == 'Spouse'){ 
                            fileNames.push('I-539');
                        }
                        if(this.checkProperty(selectedData, 'userType') == 'Children'){ 
                            if(this.spouseExists){
                                fileNames.push('I-539A'); 
                            }else{
                                if(this.checkProperty(selectedData, 'childIndex')>1){
                                    fileNames.push('I-539A'); 
                                }else{
                                    fileNames.push('I-539');
                                }
                                
                            }
                        }
                        
                    }
                    if(this.selectedCategory == 'h4ead'){
                        fileNames.push('I-765');
                    }
                    fileNames.push('Receipt Notice.pdf');
                    
                }
                if(fileNames && this.checkProperty(fileNames, 'length')>0 ){
                    documents[0].name = fileNames.join('_');
                }
                return documents;
            }else{
                let doc = []
                return doc
            }
        },
        submitForm(){
            this.$validator.validateAll("trackingform").then((result) => {
                this.receiptNoticesUpdateError = '';
                if(result){
                    let path = "/petition/manage-tracking-details";
                    if(this.isAlreadyUpdated){
                        path = '/petition/update-tracking-details'
                    }
                    let payLoad = {
                        petitionId:this.checkProperty(this.petition, '_id'),
                        notifyPetitioner:this.notifyPetitioner,
                        action:this.selectedAction,
                        items:[],
                        aiReqCronId:this.aiReqCronId,
                        linkFromAiTools:true,
                    }
                    if(this.selectedCategory != 'beneficiary' ){
                        payLoad['category'] = this.selectedCategory
                    }
                    if(this.selectedTrackingData){
                        let obj = {
                            receiptName:this.checkProperty(this.selectedTrackingData,'receiptName'),
                            receiptNumber:this.checkProperty(this.selectedTrackingData,'receiptNumber'),
                            documents:this.getNoticeDocName(this.selectedTrackingData),
                            userType:this.checkProperty(this.selectedTrackingData,'userType'),
                            userName:this.checkProperty(this.selectedTrackingData,'userName'),
                            receivedDate:this.checkProperty(this.selectedTrackingData,'receivedDate')
                        } 
                        if(this.checkProperty(this.selectedTrackingData,'childrenId')){
                            obj['childrenId'] = this.checkProperty(this.selectedTrackingData,'childrenId')
                        }
                        payLoad['items'].push(obj)
                       //payLoad['items'].push(this.selectedTrackingData) 
                    };
                    this.loading = true;
                    this.$store.dispatch("commonAction", { data: payLoad, path: path }).then((res)=>{
                        this.loading = false;
                        this.showToster({ message:res.message , isError: false})
                        this.hideReceipt(true);
                    }).catch((err)=>{
                        this.receiptNoticesUpdateError =err;
                        this.loading = false;
                    })
                }
            })
        }
    },
    watch: {
    },
    mounted() {
        if(this.checkProperty(this.petition, 'companyDetails', 'name')){
            this.companyName = this.checkProperty(this.petition, 'companyDetails', 'name')
        }
        if([1].indexOf(this.checkProperty(this.petition, 'typeDetails', 'id'))>-1){
            this.isH1bCase = true;
        }
        if([2].indexOf(this.checkProperty(this.petition, 'typeDetails', 'id'))>-1){
            this.isH4Case = true;
        }
        if([5].indexOf(this.checkProperty(this.petition, 'typeDetails', 'id'))>-1){
            this.isL1Case = true;
        }
        if([11].indexOf(this.checkProperty(this.petition, 'typeDetails', 'id'))>-1){
            this.isL2Case = true;
        }
        this.getReceiptData();
        setTimeout(()=>{
            this.$modal.show('receiptUpdatesForm');
        })
        
    },
    data: () => ({
        spouseExists:false,
        companyName:'',
        receiptNoticesUpdateError:'',
        loading:false,
        notifyPetitioner:false,
        isAlreadyUpdated:false,
        selectedCategory:'',
        selectedAction:'',
        selectedTrackingData:null,
        receiptDataList:[],
        benSelected:false,
        isH1bCase:false,
        isL1Case:false,
        isL2Case:false,
        isH4Case:false,
    }),
    props: { 
        aiReqCronId: {
            type: String,
            default: null,
        },
        documentDetail: {
            type: Object,
            default: null,
        },
        ACTIVITYCODE: {
            type: String,
            default: null,
        },
        petition: {
            type: Object,
            default: null,
        },
        caseCurrentDetails:{
            type: Array,
            default: []
        },
    },
    computed:{
        checkSectionVal(){
            return(code='')=>{
                let returnVal = null;
                if(code){
                    returnVal = _.find( this.receiptDataList, {'type':code });
                }
                return returnVal;
            }
        },
        returnSelectedObj(){
            this.receiptNoticesUpdateError = '';
            this.loading = false;
            this.notifyPetitioner = false;
            this.isAlreadyUpdated = false;
            this.selectedCategory = '';
            this.selectedTrackingData = null;
            this.selectedAction = ''
            let returnVal = null;
            returnVal = _.find( this.receiptDataList, {'isSelected':true });
            if(returnVal){
                let obj = {
                    receiptName:'',
                    receiptNumber:'',
                    documents:[],
                    userType:returnVal['subTitle'],
                    userName:returnVal['name'],
                    receivedDate:null
                } 
                if(this.documentDetail){
                    obj['documents'].push(this.documentDetail)
                }
                if(returnVal['childrenId']){
                    obj['childrenId'] = returnVal['childrenId']
                }
                if(returnVal['childIndex']){
                    obj['childIndex'] = returnVal['childIndex']
                }
                if(returnVal['receiptNumber'] !=''){
                    obj['receiptNumber'] = returnVal['receiptNumber']
                }
                if(returnVal['receivedDate'] !=''){
                    obj['receivedDate'] = returnVal['receivedDate']
                }
                if(returnVal['isAlreadyUpdated']){
                    this.isAlreadyUpdated = true
                }
                this.selectedCategory = returnVal['type'];
                this.selectedAction = returnVal['action'];
                this.selectedTrackingData = obj;
            }
            return returnVal
        }
    }
  };
  </script>
  